module.exports = __webpack_public_path__ + "static/media/three.6f4088b0.png";